module.exports = __webpack_public_path__ + "static/good-girl-bad-girl-8d279ad04eb9fe01e7cda56284ff07ec.jpg";